import Axios from "../../../../api/axios/Axios";

export const getLatestHomeAlbums = async ({
  limit = 5,
  offset = 0,
  signal,
} = {}) => {
  const response = await Axios.get("/api/home/albums", {
    params: {
      limit,
      offset,
    },
    signal,
  });

  return response.data;
};
